import axios, {AxiosResponse} from 'axios'
import {ID, WoosatTelecomResponse, Response} from '../../../../../_metronic/helpers'
import {PurchasedProduct, PurchasedProductsQueryResponse} from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PURCHASEDPRODUCT_URL = `${API_URL}/admin/purchased-products`
const GET_PURCHASEDPRODUCTS_URL = `${API_URL}/admin/purchased-products`

const getPurchasedProducts = (query: string): Promise<PurchasedProductsQueryResponse | WoosatTelecomResponse<PurchasedProduct[]>> => {
  return axios
    .get(`${GET_PURCHASEDPRODUCTS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<PurchasedProduct[]>>) => {
      return d.data
    })
}

const getPurchasedProductById = async (id: ID): Promise<PurchasedProduct> => {
  try {
    const {data} = await axios.get(`${PURCHASEDPRODUCT_URL}/${id}`)
    return data?.data?.purchasedproduct
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
  // return axios.get(`${PURCHASEDPRODUCT_URL}/${id}`).then((response: AxiosResponse<PurchasedProduct>) => response.data)
}
const createPurchasedProduct = (purchasedproduct: PurchasedProduct): Promise<PurchasedProduct | undefined> => {
  
  const formData = new FormData();
  Object.entries(purchasedproduct).forEach(([key, value]) => {
    // Handle image separately
      formData.append(key, value);
  });

  return axios
    .post(PURCHASEDPRODUCT_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
   .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<PurchasedProduct>) => response.data)
}


const updatePurchasedProduct = (purchasedproduct: PurchasedProduct): Promise<PurchasedProduct | undefined> => {
  const newFormData = new FormData();
  Object.entries(purchasedproduct).forEach(([key, value]) => {
    // Handle image separately
      newFormData.append(key, value);
  });
  // newFormData.append('_method','put');
  return axios
    .post(`${PURCHASEDPRODUCT_URL}/${purchasedproduct.id}`, newFormData,{
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
   .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<PurchasedProduct>) => response.data)
}


const deletePurchasedProduct = (purchasedproductId: ID): Promise<void> => {
  return axios.delete(`${PURCHASEDPRODUCT_URL}/${purchasedproductId}`).then((response) => {
    if(response.data.success == true){
      toast.success(response?.data?.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  })
}

const deleteSelectedPurchasedProducts = (purchasedproductIds: Array<ID>): Promise<void> => {
  const requests = purchasedproductIds.map((id) => axios.delete(`${PURCHASEDPRODUCT_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getPurchasedProducts,
  deletePurchasedProduct,
  deleteSelectedPurchasedProducts,
  getPurchasedProductById,
  createPurchasedProduct,
  updatePurchasedProduct,
}
